import moment from 'moment';

/**
 * Registers the moment locales the dashboard supports, in the INITIAL bundle.
 *
 * `extend.webpack.config.js` drops moment's dynamic `./locale` context (it pulled all 138
 * locales into main.js), so the only locales available at runtime are the ones imported
 * explicitly here. They must live in the initial bundle rather than a lazy chunk:
 * `MomentDateAdapter` reads month names and `firstDayOfWeek` through
 * `moment.localeData(locale)`, which silently returns the global `en` locale for anything
 * unregistered — so locales reachable only from a lazily-loaded feature would leave every
 * other date picker in the app rendering English, Sunday-first dates for non-English partners.
 *
 * Two code shapes reach moment and both must be covered:
 *   - the full app code (`de_CH`), which moment normalises to `de-ch`;
 *   - the bare code, from the four `setLocale(lang.split('_')[0])` call sites in
 *     `calio-date-picker` and `calio-partner-settings` — those ask for `de`, `fr`, `it`.
 * `nl/fi/pl/es/sv` are registered under their bare code already, so only the three Swiss
 * regional locales need their short form as well. An unregistered code does not throw —
 * moment silently returns the global `en`, i.e. English, Sunday-first.
 *
 * `en_US` needs no import; `en` is moment's built-in locale.
 */
import 'moment/locale/de';
import 'moment/locale/fr';
import 'moment/locale/it';
import 'moment/locale/de-ch';
import 'moment/locale/en-gb';
import 'moment/locale/en-au';
import 'moment/locale/en-ca';
import 'moment/locale/fr-ch';
import 'moment/locale/it-ch';
import 'moment/locale/nl';
import 'moment/locale/fi';
import 'moment/locale/pl';
import 'moment/locale/es';
import 'moment/locale/sv';

// Each `moment/locale/*` file calls `defineLocale`, which also makes that locale the GLOBAL
// one — so after the imports above moment's global locale is `sv`. The dynamic context this
// replaces loaded locales on demand and left the global at `en`, and un-localed
// `moment().format()` calls throughout the app rely on that. Restore it.
moment.locale('en');
